

import React, { useEffect, useState } from 'react'
import { LoadAllAbout, LoadAllAccueilComposant } from '../actions/ActivitesPages/ManagerPageAction';
import AllRoutes from '../nametitle/AllRoutes';
import LoadingProfile from '../components/LoadingProfile';
import { Navigate, useNavigate } from 'react-router-dom';
import SocialMedia from '../components/SocialMedia';
import LocationChurch from '../components/LocationChurch';
import { getDataFromFile } from '../actions/SearchAction';
import { Localvalue } from '../nametitle/localValue';

const AboutUsPage = () => {
    const navigate = useNavigate();




    const [id, setid] = useState();

    const [coverPictureHome1, setcoverPictureHome1] = useState();
    const [videoHome, setVideoHome] = useState();
    const [titleHome, settitleHome] = useState();
    const [strategy, setstrategy] = useState();
    const [description1, setdescription1] = useState();
    const [content, setcontent] = useState();

    // Accitite 2
    const [coverPictureHome2, setcoverPictureHome2] = useState();
    const [titleHome2, settitleHome2] = useState();
    const [description2, setdescription2] = useState();

    const [LoadingAll, setLoadingAll] = useState([]);

    useEffect(() => {
        const object = getDataFromFile(Localvalue.activitePageData);
        setVideoHome(object&& object.about && object.about.activite1 && object.about.activite1.video ? object.about.activite1.video : "");
        setcoverPictureHome1(object && object.about && object.about.activite1 && object.about.activite1.coverPicture ? object.about.activite1.coverPicture :"");
        settitleHome(object && object.about && object.about.activite1 && object.about.activite1.title ? object.about.activite1.title : "" );
        setcontent(object && object.about && object.about.activite1 && object.about.activite1.content ? object.about.activite1.content : "");
        setdescription1(object && object.about && object.about.activite1 && object.about.activite1.description ? object.about.activite1.description : "");
        setstrategy(object && object.about && object.about.activite1 && object.about.activite1.strategy ? object.about.activite1.strategy : "");
        // ***************************************************     Activté 2
        setcoverPictureHome2(object && object.about && object.about.activite2 && object.about.activite2.coverPicture ? object.about.activite2.coverPicture :"" );
        settitleHome2(object && object.about && object.about.activite2 && object.about.activite2.title ? object.about.activite2.title :"");
        setdescription2(object && object.about && object.about.activite2 && object.about.activite2.description ? object.about.activite2.description : "" );
        LoadAllAccueilComposant(setLoadingAll);
        LoadAllAbout(
            setid, setVideoHome, setcoverPictureHome1, settitleHome, setdescription1, setstrategy, setcontent,
            setcoverPictureHome2, settitleHome2, setdescription2
        );
    }, []);
    return (
        <div>
            {
                titleHome || content  ?
                    <div>




                        <div className="min-h-screen flex justify-center items-center bg-cover bg-center" style={{
                            backgroundImage: `linear-gradient(rgb(0 0 0 / 60%), rgb(0 0 0 / 60%)) ,url('${coverPictureHome1}')`,
                            backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'
                        }}>
                            <div className="absolute top-0 left-0 mt-5 ml-5">

                            </div>
                            <div className="space-y-5">

                                <p className="text-white font-bold text-5xl flex flex-col items-center">
                                    <div className="border-center border-3 rounded-lg border-primary px-3 py-2 ps-5 mb-5 translatable">
                                        <span className="translatable">{titleHome}</span>
                                    </div>
                                </p>
                                <p className="text-white px-10 text-center text-lg flex flex-col items-center translatable">
                                    {content}
                                </p>
                                <div className="flex flex-row items-center justify-center">
                                    <button
                                        onClick={() => {
                                            navigate(`/${AllRoutes.contact}`)
                                        }}
                                        className="p-1 py-2 px-3 rounded-lg text-l font-semibold bg-lime-600 hover:bg-lime-700 text-white translatable">Nous contacter </button>
                                </div>
                            </div>
                        </div>





                        <div className="py-16 bg-white ">
                            <div className="container m-auto px-6 text-gray-600 md:px-12 xl:px-6 border rounded-lg shadow-md py-5">
                                <div className="space-y-6 md:space-y-0 md:flex md:gap-6 lg:items-center lg:gap-12">
                                    <div className="md:5/12 lg:w-5/12">
                                        <img src={coverPictureHome2} alt="image" loading="lazy" width="" height="" />
                                    </div>
                                    <div className="md:7/12 lg:w-6/12 mb-5">
                                        <h2 className="text-2xl text-lime-700 font-bold md:text-4xl translatable">{titleHome}</h2>
                                        <p className="mt-6 text-gray-600 translatable">
                                            {description2}
                                        </p>
                                    </div>

                                    <a href={`/${AllRoutes.contact}`} className="btn btn-primary btn-md py-2 px-4 rounded-lg  me-3 translatable">rejoindre</a>

                                </div>
                            </div>
                        </div>

                        <SocialMedia />

                        <LocationChurch />


                    </div>
                    : <LoadingProfile />
            }

        </div>
    )
}

export default AboutUsPage